/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {observer} from 'mobx-react';
import {useStore} from '../../../../../../store/store';
import Filters from '../../../../../table/new/filters/Filters';
import Presets from '../../../../../table/new/Presets';
import {getFilters} from './new/getFilters';
import {facebookStatisticsFilters} from './new/filtersConfigs';
import {facebookStatisticsGroups} from './new/groupsConfigs';
import TableWrapper from '../../../../../table/new/TableWrapper';
import {baseFields} from '../../../../../table/new/customizationTable';
import BlankSheet from '../../../../../table/new/BlankSheet';
import FullScreen from '../../../../../table/new/FullScreen';
import Refresh from '../../../../../table/new/Refresh';
import ResultsCount from '../../../../../table/new/ResultsCount';
import Search from '../../../../../table/new/SearchForTable';
import Columns from '../../../../../table/new/Columns';
import {useFullWidth} from '../../../../../hooks/useFullWidth';
import AddTarget from '../BloggersHeader/AddTarget';

const Stream = ({
  id,
  setPrevTimeConfig,
  prevTimeConfig,
  timeConfig,
  isVerify,
  setPreloader,
  CalendarForFullScreen,
}) => {
  useFullWidth(true);
  const location = useLocation();
  const store = useStore();

  const [newPrevTimeConfig, setNewPrevTimeConfig] = useState(null);

  useEffect(() => {
    if (prevTimeConfig !== null) {
      setNewPrevTimeConfig(prevTimeConfig);
    }
  }, [prevTimeConfig]);

  return (
    <TableWrapper
      branch={'inf'}
      setPreloader={setPreloader}
      timeConfig={timeConfig}
      isVerify={isVerify}
      setPrevTimeConfig={setPrevTimeConfig}
      prevTimeConfig={newPrevTimeConfig}
      getMethod={'Dashboard/Influence/Statistics'}
      getFilters={getFilters}
      // setEditItemId={setEditItemId}
      CalendarForFullScreen={CalendarForFullScreen}
      edit={null}
      defaultFilters={[
        {
          filter: 'state',
          isFixed: true,
          options: [],
        },
        {filter: 'bayer_id', isFixed: true, options: []},
        {filter: 'offer_id', isFixed: true, options: []},
        {filter: 'link_id', isFixed: true, options: []},
        {filter: 'inf_traffic_id', isHidden: true, isFixed: true, options: []},
      ]}
      defaultGroups={[{group: 'inf_source', isFixed: true}]}
      //на випадок якщо нам взагалі не потрібно показувати вибір груп
      hasHiddenGroups={true}
      baseFields={baseFields.filter((item) => item.value !== 'clicks')}
      disabledByDefault={[
        'click2reg',
        'click2cpa',
        'lead2fd',
        'lead2cpa',
        'chat2reg',
        'reg2cpa',
        'fd2cpa',
        'reg2rs',
        'chat2rs',
        'lead2rs',
        'click2rs',
      ]}
      idForChangeSize={'bloggerHeader'}
    >
      <Filters
        facebookStatisticsFilters={facebookStatisticsFilters}
        facebookStatisticsGroups={facebookStatisticsGroups}
        childrenNearGroups={
          <>
            <AddTarget traffic_id={id} />
            <Search />
          </>
        }
        childrenHead={false}
        childrenRefresh={false}
        childrenByFilters={<Refresh />}
        childrenPresets={
          <>
            <ResultsCount />
            <BlankSheet />
            <Columns columns={baseFields} />
            <Presets />
            <FullScreen />
          </>
        }
      />
    </TableWrapper>
  );
};

export default observer(Stream);
